export const TRACKING_PAGE_TYPES = {
  HOMEPAGE: 'homepage'
};
